<!-- components/TransactionModal.vue -->
<template>
    <transition name="modal-overlay">
        <div
            v-if="isOpen"
            class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            @click="emitClose"
        >
            <transition name="modal-content">
                <div
                    v-if="isOpen"
                    class="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 relative"
                    @click.stop
                >
                    <!-- Header -->
                    <div class="flex justify-between items-center p-6">
                        <h2 class="w-full text-lg text-center font-medium text-gray-700">
                            TRANSACTION DETAILS
                        </h2>
                        <button
                            class="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                            @click="emitClose"
                        >
                            <svg
                                class="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    d="M6 18L18 6M6 6l12 12"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                />
                            </svg>
                        </button>
                    </div>

                    <!-- Body -->
                    <div class="p-6">
                        <div
                            class="border border-gray-200 rounded-lg p-4 divide-y divide-gray-200"
                        >
                            <div
                                v-for="(value, key) in transaction"
                                :key="key"
                                class="flex justify-between items-center py-4"
                            >
                                <span class="text-gray-600 capitalize">{{ key }}</span>
                                <span class="text-gray-800">{{ value }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script setup>
import { onMounted, onUnmounted, defineProps, defineEmits } from "vue";

const props = defineProps({
    isOpen: { type: Boolean, required: true },
    transaction: { type: Object, required: true },
});

const emit = defineEmits(["close"]);

const emitClose = () => {
    emit("close");
};

const handleEscape = (event) => {
    if (event.key === "Escape" && props.isOpen) {
        emitClose();
    }
};

onMounted(() => {
    document.addEventListener("keydown", handleEscape);
});

onUnmounted(() => {
    document.removeEventListener("keydown", handleEscape);
});

</script>

<style scoped>
.modal-overlay-enter-active,
.modal-overlay-leave-active {
    transition: opacity 0.3s ease;
}
.modal-overlay-enter-from,
.modal-overlay-leave-to {
    opacity: 0;
}
.modal-overlay-enter-to,
.modal-overlay-leave-from {
    opacity: 1;
}
.modal-content-enter-active,
.modal-content-leave-active {
    transition: all 0.3s ease;
}
.modal-content-enter-from,
.modal-content-leave-to {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
}
.modal-content-enter-to,
.modal-content-leave-from {
    opacity: 1;
    transform: scale(1) translateY(0);
}
</style>
